
export default {

    treatmentPlan: 'Treatment plan ',
    lastFollow: 'Last follow up',
    newFollow: 'New follow up',
    closeDate: 'Close date',
    assetImpact: 'Asset / Impact',
    riskId: 'Risk ID',
    controlId: 'Control ID',

}